import { ref, watch } from 'vue';
import { getAllTaskList } from '@blade-sxp/monitoring-center/api';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store';
export const useTaskList = () => {
    const store = useMonitoringStore();
    const taskList = ref([]);
    const isSesstionTask = !!sessionStorage.getItem('checkedTasks');
    const checkedTasks = isSesstionTask ? JSON.parse(sessionStorage.getItem('checkedTasks') || '') : null; // 任务告警展示List
    const recieveAlerts = isSesstionTask ? JSON.parse(sessionStorage.getItem('recieveAlerts') || '') : null; // 接收任务告警弹框List
    watch(taskList, () => {
        // 更新任务列表数据
        store.updateTaskList(taskList.value);
        updateStorageData();
    }, { deep: true });
    const updateStorageData = () => {
        sessionStorage.setItem('checkedTasks', JSON.stringify(store.checkedTasks));
        sessionStorage.setItem('recieveAlerts', JSON.stringify(store.recieveAlerts));
    };
    const onTaskChange = (item) => {
        if (!item.checked) {
            item.recieveAlert = false;
        }
    };
    // 获取任务list
    const getTaskList = async () => {
        taskList.value = await fetchAllTaskList(recieveAlerts, checkedTasks);
    };
    return { getTaskList, onTaskChange, taskList };
};
const fetchAllTaskList = (recieveAlerts, checkedTasks) => {
    const params = {
        taskTypes: [],
        onlyAlert: true,
    };
    let list = [];
    return getAllTaskList(params).then((res) => {
        if (!res)
            return [];
        list = res.map((item) => {
            return {
                ...item,
                recieveAlert: recieveAlerts ? recieveAlerts.includes(item.id) : false,
                checked: checkedTasks ? checkedTasks.includes(item.id) : true
            };
        });
        return list;
    });
};
